import { render, staticRenderFns } from "./ot-duration-selection-wrapper.vue?vue&type=template&id=5a33d691&scoped=true&"
import script from "./ot-duration-selection-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-duration-selection-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-duration-selection-wrapper.vue?vue&type=style&index=0&id=5a33d691&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a33d691",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
